// extracted by mini-css-extract-plugin
module.exports = {"SaveProfileInfo":"SaveProfileInfo_SaveProfileInfo__bsoHk"};